var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 6.44531C13.3504 6.44531 12.6758 5.77066 12.6758 4.94141V0H4.98438C3.68126 0 2.62109 1.06017 2.62109 2.36328V19.6367C2.62109 20.9398 3.68126 22 4.98438 22H17.0156C18.3187 22 19.3789 20.9398 19.3789 19.6367V6.44531H14.1797ZM6.14453 15.4688H9.26922C9.62517 15.4688 9.91375 15.7573 9.91375 16.1133C9.91375 16.4692 9.62517 16.7578 9.26922 16.7578H6.14453C5.78858 16.7578 5.5 16.4692 5.5 16.1133C5.5 15.7573 5.78858 15.4688 6.14453 15.4688ZM5.5 12.6758C5.5 12.3198 5.78858 12.0312 6.14453 12.0312H15.5977C15.9536 12.0312 16.2422 12.3198 16.2422 12.6758C16.2422 13.0317 15.9536 13.3203 15.5977 13.3203H6.14453C5.78858 13.3203 5.5 13.0317 5.5 12.6758ZM15.5977 8.59375C15.9536 8.59375 16.2422 8.88233 16.2422 9.23828C16.2422 9.59423 15.9536 9.88281 15.5977 9.88281H6.14453C5.78858 9.88281 5.5 9.59423 5.5 9.23828C5.5 8.88233 5.78858 8.59375 6.14453 8.59375H15.5977Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9648 4.94168C13.9648 5.06014 14.0612 5.15652 14.1797 5.15652H19.0916C18.9737 4.93884 18.822 4.73891 18.6398 4.56647L14.4966 0.646777C14.3358 0.494668 14.1567 0.367781 13.9649 0.267578V4.94168H13.9648Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.7dd7fa45d6bf44fa32b438397dde7095.svg";
export { ForwardRef as ReactComponent };